import dayjs from "dayjs"
import relativeTime from "dayjs/plugin/relativeTime"
import { useRecoilState } from "recoil"
import { currectOrderAtom } from "../config/atoms"
import "./ordercard.css"

dayjs.extend(relativeTime)

export default function OrderCard({ item, showOrder, width }) {

    const [curOrder, setCurrentOrder] = useRecoilState(currectOrderAtom)

    function getColor(state) {
        switch (item.status) {
            case "Cancelled":
            case "rejected":
                return {
                    color: 'var(--errorColor)',
                }
            case "orderready":
            case "Accepted":
            case "Closed": 
                return {
                    color: 'var(--successColor)',
                }
            default:
                return {
                    color: 'var(--warnColor)'
                }
        }
    }

    return (
        <div className="card-wrapper card" onClick={() => {
            setCurrentOrder(item)
            showOrder(item?.id)
        }} style={{
            borderLeftColor: getColor().color,
            backgroundColor: curOrder?.id === item.id ? "var(--warnColor)" : "var(--card)"
        }}>
            <div className="card-titles">
                <p>{item.title}</p>
                {width > 768 && <p>{item.phone}</p>}
                <p>Status: {item.status === "orderready" ? "In Prep" : item.status}</p>
                <p>{dayjs(item.date).fromNow()}</p>
            </div>
            {/* <div className="card-titles" style={{ borderBottomWidth: 0 }}>
                <p>Type: Delivery</p>
                <p>Payment: Card</p>
            </div> */}
        </div>
    )
}